import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default props => {
    const map = useMapContext()
    map.useNodeChange(map.root, ['data'])
    const {mapTypeCode} = map.data
    const {rmType} = map.root.data

    if (
        '_RULEMRM_MAP' !== mapTypeCode ||
        'SUMMARY' !== rmType
    ) {
        return null
    }

    const onClick = () => {
        const {pkid: rmId, prjId, rmCode, rmName, rmNo, sVer} = map.root.data

        openWindow(
            '/Ai',

            {
                bizMap: {rmCode, rmId, rmName, rmNo},
                prjId,
                scene: 'GENERATE_SUMMARY',
                sVer,
                title: `知识模块: ${rmName}`,
            }
        )
    }

    return {
        label: '系统概述',
        onClick,
        ...props,
    }
}
